import Inspection from '../models/Inspection';

/**
 * Will return true if the provided inspection is considered "completed",
 * which means that completedAt is not null.
 *
 * @param inspection - The inspection to check
 */
export default function inspectionIsCompleted(inspection: Inspection): boolean {
  return inspection.completedAt !== null;
}
